import { dispatch } from '@wordpress/data';

/**
 * animate slider track
 * @param {int} sliderIndex - animate to slide index
 * @param {int} slidesCount - slide count
 * @param {DOM object} el_SlidesComponent 
 */
export function AnimateTrack(sliderIndex, slidesCount, el_SlidesComponent, transitionEffectValue) {

    if(el_SlidesComponent) {
        const el_superblockslider__track = el_SlidesComponent.querySelector('.superblockslider__track')

        if(el_superblockslider__track) {
            if(transitionEffectValue == 'slide') {
                const offsetPercent = 100 / slidesCount;
                const translateXOffset = sliderIndex * offsetPercent
                const translateX = `translateX(-${translateXOffset}%)`
                el_superblockslider__track.style.transform = translateX
            }
            else if (transitionEffectValue == 'fade') {
                el_superblockslider__track.style.transform = 'translateX(0%)'
            }
        }

        // remove active button
        const el_superblockslider__button__active = el_SlidesComponent.querySelector('.superblockslider__button--active')
        if(el_superblockslider__button__active) {
            el_superblockslider__button__active.classList.remove('superblockslider__button--active')
        }
        // remove active slide
        const el_superblockslider__slide__active = el_SlidesComponent.querySelector('.superblockslider__slide--active')
        if(el_superblockslider__slide__active) {
            el_superblockslider__slide__active.classList.remove('superblockslider__slide--active')
            // dispatch('core/block-editor').updateBlockAttributes(el_superblockslider__slide__active.getAttribute('data-block'), { isActiveSlide: false })
        }

        // add active button
        const el_superblockslider__button = el_SlidesComponent.querySelectorAll('.superblockslider__button')
        if(el_superblockslider__button[sliderIndex]) {
            el_superblockslider__button[sliderIndex].classList.add('superblockslider__button--active')
        }
        // add active slide
        const el_superblockslider__slides = el_SlidesComponent.querySelectorAll('.superblockslider__slide')
        // console.log(el_SlidesComponent)
        // console.log(el_superblockslider__slides)
        if(el_superblockslider__slides[sliderIndex]) {
            el_superblockslider__slides[sliderIndex].classList.add('superblockslider__slide--active')
            // dispatch('core/block-editor').updateBlockAttributes(el_superblockslider__slides[sliderIndex].getAttribute('data-block'), { isActiveSlide: true })
        }
    }

}